<template>
  <div class="ma-11">
    <v-row justify="start" align="center">
      <v-icon left>mdi-virus</v-icon>
      <span class="grey--text title">Penyakit</span>
      <v-spacer></v-spacer>
      <penyakit @onChange="gantiTampilan" />
    </v-row>
    <v-divider class="mt-5 mb-11"></v-divider>
    <v-card class="pa-3">
      <v-data-table
        v-if="tampil"
        :loading="loading"
        :items="data"
        :headers="header"
        no-data-text="Belum ada data"
        loading-text="Memuat data ...."
      >
        <template v-slot:item.kode="{item}">
          <v-chip small dark color="primary">
            <span>{{item.kode}}</span>
          </v-chip>
        </template>

        <template v-slot:item.keterangan="{item}">
          <span class="grey--text caption">{{item.keterangan}}</span>
        </template>

        <template v-slot:item.pengendalian="{item}">
          <span class="grey--text caption">{{item.pengendalian}}</span>
        </template>

        <template v-slot:item.aksi="{item}">
          <v-row>
            <penyakit @onChange="gantiTampilan" :item="item" />
            <penyakit @onChange="gantiTampilan" :item="item" :isDelete="true" />
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import penyakit from "@/components/PenyakitForm.vue";
import fs from "@/fb";
export default {
  components: {
    penyakit
  },
  mounted() {
    this.loading = true;
    fs.penyakit.onSnapshot(snapshot => {
      this.data = [];
      snapshot.forEach(doc => {
        this.data.push({
          id: doc.id,
          ...doc.data()
        });
      });
      this.loading = false;
    });
  },
  methods: {
    gantiTampilan: function() {
      this.tampil = false;
      setTimeout(() => {
        this.tampil = true;
      }, 1);
    }
  },
  data() {
    return {
      data: [],
      tampil: true,
      loading: false,
      header: [
        {
          text: "Kode",
          value: "kode"
        },
        {
          text: "Nama Penyakit",
          value: "nama"
        },
        {
          text: "Keterangan",
          value: "keterangan"
        },
        {
          text: "Pengendalian Penyakit",
          value: "pengendalian"
        },
        {
          text: "Opsi",
          value: "aksi",
          sortable: false
        }
      ]
    };
  }
};
</script>